import React, { useRef } from 'react'
import Experience from './Experience.jsx'

import EXPERIENCE_EL_CAMBIO_IMAGE_PATH from 'images/experience_el_cambio.jpg'
import EXPERIENCE_EL_CAMBIO_SONG_PATH from 'audio/8. DAÑO MB.mp3'

import useVantas from '../../use_vantas.js'

import WAVES from 'vanta/src/vanta.waves.js'
import { gsap } from 'gsap'

const ElCambioText = () => (
	<span className="text-center">
		<p>Recorriste el camino:</p>
		<p>Te entregaste al análisis, mutaste, danzaste con los ciclos, abrazaste la resiliencia, te descalzaste, conversaste con tu interior y reconociste tus deseos.</p>

		<p>¿Podes aceptar el daño finalmente?</p>
		<p>Transmutarlo y transformarte.</p>
		<p>Gracias a él.</p>
		<p>¿Qué es lo quisieras transformar?</p>
		<p>¿Y lo que quisieras dejar atrás?</p>

		<p>Y ahora,</p>
		<p>¿quién sos?</p>

		<p>Y,</p>
		<p>¿hacia dónde vas?</p>
	</span>
)

const ExperienceElCambio = ({ is_active, ...props }) => {
	return (<Experience
		image={EXPERIENCE_EL_CAMBIO_IMAGE_PATH}
		title={"El cambio"}
		phrase={"¿Qué podrías transformar hoy si te asumieras como el agente vivo de tu propia transmutación?"}
		phrase_rect={{ top: 90, left: 50, width: 70, height: 20 }}
		text={<ElCambioText />}
		text_rect={{ top: 40, left: 76.5, width: 40, height: 75 }}
		text_interaction_zone_rect={{ top: 20, left: 13, width: 13, height: 15 }}
		song={EXPERIENCE_EL_CAMBIO_SONG_PATH}
		song_rect={{ top: 36, left: 46, width: 10, height: 10 }}
		is_active={is_active}
		{...props}
	/>)
}

export default ExperienceElCambio